var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleinline = function SvgCheckCircleinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 .5a10.5 10.5 0 1 0 0 21 10.5 10.5 0 0 0 0-21M9.5 15.193l-3.75-3.75 1.193-1.193L9.5 12.807l5.557-5.557 1.197 1.19z"
  })));
};
export default SvgCheckCircleinline;